module.exports = __webpack_public_path__ + "static/media/TUDublin.97eace63.png";